import { CenteredStatus } from "shared/src/components/CenteredStatus/CenteredStatus"
import { useQuery } from "shared/src/libs/queryLib/queryLib"

export function AccessDenied(): JSX.Element {
	const query = useQuery()
	const message = query.get("message")
	return <CenteredStatus isLoading={false}>{message ? message : "Access Denied"}</CenteredStatus>
}
